import {FC, useEffect, useState} from 'react'
import {ICDRLine} from '../core/_models'
import {KTSVG} from '../../../template/helpers'
import {cdrAPI} from '../../../services/CDRService'
import clsx from 'clsx'
import {useParams} from 'react-router-dom'

type Props = {
  line: ICDRLine
  handleCancel: () => void
}

const CDRSettingsLineItem: FC<Props> = ({line, handleCancel}) => {
  const {appId} = useParams()
  const [lineName, setLineName] = useState<string>(line.name)
  const [linesState, setLinesState] = useState<boolean>(false)
  const [lineNumber, setLineNumber] = useState<string>(line.number)
  const [upsertLineIsError, setUpsertLineIsError] = useState<boolean>(false)
  const [upsertLines, {isLoading: isLoadingMutationUpsert}] = cdrAPI.useUpsertLinesMutation()
  const [deleteLine, {isLoading: isLoadingMutationDelete}] = cdrAPI.useDeleteLineMutation()

  useEffect(() => {
    if (line.id === undefined) {
      setLinesState(true)
    }
  }, [line])

  const handleUpsertLine = () => {
    if (lineNumber && lineName) {
      const newLine: ICDRLine = {
        number: lineNumber.trim(),
        name: lineName.trim(),
      }
      if (line.id !== undefined) {
        newLine.id = line.id
      }
      upsertLines({app_id: appId!, lines: [newLine]})
      setLinesState(false)
    } else {
      setUpsertLineIsError(true)
    }
  }

  const handleDeleteLine = () => {
    if (line.id !== undefined) {
      deleteLine({app_id: appId!, line_ids: [line.id!]})
    }
  }

  return (
    <>
      <tr role='row' className='text-gray-900 text-center'>
        {!linesState && (
          <>
            <td role='cell' className='min-w-150px p-2 px-0'>
              <div>{lineNumber}</div>
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <div>{lineName}</div>
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <button
                type='button'
                onClick={() => {
                  setLinesState(true)
                }}
                className='btn btn-icon btn-light-primary btn-sm me-1 align-self-center'
              >
                <KTSVG path='/media/icons/duotune/art/art005.svg' className='align-self-center' />
              </button>
            </td>
          </>
        )}
        {linesState && (
          <>
            <td role='cell' className='min-w-150px p-2 px-1'>
              <input
                name={`cdr-line-number-${line.id}`}
                className={clsx(
                  'form-control form-control-sm form-control-flush px-0 text-center bg-light-secondary rounded',
                  upsertLineIsError && lineNumber === '' ? 'bg-light-danger' : 'bg-light-secondary'
                )}
                value={lineNumber}
                onChange={(e) => {
                  setLineNumber(e.target.value)
                }}
              />
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <input
                name={`cdr-line-name-${line.id}`}
                className={clsx(
                  'form-control form-control-sm form-control-flush px-0 text-center bg-light-secondary rounded',
                  upsertLineIsError && lineName === '' ? 'bg-light-danger' : 'bg-light-secondary'
                )}
                value={lineName}
                onChange={(e) => {
                  setLineName(e.target.value)
                }}
              />
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <button
                title='Save'
                className='btn btn-icon btn-light-success btn-active-color-light btn-sm me-1 align-self-center'
                onClick={handleUpsertLine}
                disabled={isLoadingMutationUpsert || isLoadingMutationDelete}
              >
                {!isLoadingMutationUpsert && (
                  <KTSVG path='/media/icons/duotune/general/gen037.svg' className='align-self-center' />
                )}
                {isLoadingMutationUpsert && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    <span className='spinner-border spinner-border-sm align-middle'></span>
                  </span>
                )}
              </button>
              <button
                className='btn btn-icon btn-light-primary btn-active-color-light btn-sm me-1 align-self-center'
                title='Cancel'
                onClick={() => {
                  setLineNumber(line.number)
                  setLineName(line.name)
                  setLinesState(false)
                  handleCancel()
                }}
              >
                <KTSVG path='/media/icons/duotune/general/gen034.svg' className='align-self-center' />
              </button>
              <button
                title='Delete'
                onClick={handleDeleteLine}
                className='btn btn-icon btn-light-danger btn-active-color-light btn-sm me-1 align-self-center'
              >
                {!isLoadingMutationDelete && (
                  <KTSVG path='/media/icons/duotune/general/gen027.svg' className='align-self-center' />
                )}
              </button>
            </td>
          </>
        )}
      </tr>
    </>
  )
}

export {CDRSettingsLineItem}
